import styled from 'styled-components';
import { BorderTop } from '../../../src/styled/shared-styles';
import { getColor, getColorShade, getElevation, getFontFamily, getHintColor, getSizeBy, getThemeProp } from '../../../src/styled/utils';
import { groupRadius } from '../../styled/utils';
const getBorderColor = (isFocused, theme, hintType) => {
    if (isFocused)
        return getColor('primary')({ theme });
    if (hintType)
        return getHintColor(hintType)({ theme });
    return getColorShade('onSurface', 'outline')({ theme });
};
const getSingleValueColor = (isDisabled, theme, hintType) => {
    if (!isDisabled && hintType) {
        return getHintColor(hintType)({ theme });
    }
    if (isDisabled) {
        return getColorShade('onSurface', 'mediumEmphasis')({ theme });
    }
    return getColor('onSurface')({ theme });
};
export const styleReactSelect = (theme, 
/* Size 'extraLarge' is deprecated, use large instead */
size, hintType, prefixIcon, groupPosition, isMulti) => ({
    control: (provided, { isFocused, isDisabled }) => ({
        ...provided,
        color: isDisabled
            ? getColorShade('onSurface', 'mediumEmphasis')({ theme })
            : getColor('onSurface')({ theme }),
        minHeight: getSizeBy(9, size)({ theme }),
        border: isDisabled ? 'none' : undefined,
        borderRadius: groupRadius(groupPosition)({ theme }),
        borderWidth: 1,
        backgroundColor: isDisabled
            ? getColorShade('onSurface', 'hover')({ theme })
            : getColor('surface')({ theme }),
        borderColor: getBorderColor(isFocused, theme, hintType),
        boxShadow: 'none',
        '&:hover': !isFocused && !isDisabled
            ? {
                borderColor: getColorShade('onSurface', 'mediumEmphasis')({ theme })
            }
            : {}
    }),
    placeholder: (provided, { isDisabled }) => ({
        ...provided,
        left: prefixIcon ? 40 : 10,
        color: isDisabled
            ? getColorShade('onSurface', 'mediumEmphasis')({ theme })
            : getColorShade('onSurface', 'lowEmphasis')({ theme }),
        fontFamily: getFontFamily('primary')({ theme }),
        fontSize: getSizeBy(3.5)({ theme }),
        lineHeight: getSizeBy(5)({ theme }),
        letterSpacing: getSizeBy(0.02)({ theme })
    }),
    singleValue: (provided, { isDisabled }) => ({
        ...provided,
        position: 'static',
        top: 'initial',
        maxWidth: 'initial',
        transform: 'none',
        color: getSingleValueColor(isDisabled, theme, hintType),
        fontFamily: getFontFamily('primary')({ theme }),
        fontWeight: 400,
        fontSize: getSizeBy(3.5)({ theme }),
        lineHeight: getSizeBy(5)({ theme }),
        letterSpacing: getSizeBy(0.03)({ theme })
    }),
    valueContainer: (provided, { isDisabled, isMulti }) => ({
        ...provided,
        fontSize: getSizeBy(3.5)({ theme }),
        padding: '0 8px 0 10px',
        display: 'flex',
        flexWrap: isMulti ? 'wrap' : 'nowrap',
        color: getSingleValueColor(isDisabled, theme, hintType),
        gap: 4
    }),
    indicatorsContainer: (provided, { isDisabled, size }) => ({
        ...provided,
        marginRight: size === 'small' ? '8px' : '12px',
        '> svg': {
            display: 'block'
        },
        'svg > *': {
            fill: isDisabled
                ? getColorShade('onSurface', 'lowEmphasis')({ theme })
                : getColorShade('onSurface', 'mediumEmphasis')({ theme })
        }
    }),
    menu: ({ ...provided }, { maxMenuHeight = 150 }) => ({
        ...provided,
        margin: `${getSizeBy(0.5)({ theme })} 0`,
        borderRadius: `${getThemeProp('borderRadius')({ theme })}px`,
        maxHeight: maxMenuHeight,
        overflowY: 'auto',
        backgroundColor: getColor('surface')({ theme }),
        boxShadow: getElevation(8)({ theme })
    }),
    menuList: (provided) => ({
        ...provided,
        padding: 0
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: getColor('onSurface')({ theme }),
        fontFamily: getFontFamily('primary')({ theme }),
        fontWeight: 400
    }),
    loadingMessage: (provided) => ({
        ...provided,
        color: getColor('onSurface')({ theme }),
        fontFamily: getFontFamily('primary')({ theme }),
        fontWeight: 400
    })
});
export const StyledSelectWrapper = styled.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 84px;
`;
export const IconContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: 10px;
`;
export const PopoverContainer = styled.div `
  margin-right: ${getSizeBy(2)};
  padding: ${getSizeBy()};
  text-align: center;
  background-color: ${getColor('surface')};
  border: 0.66px solid ${getColorShade('onSurface', 'outline')};
  border-radius: ${getThemeProp('borderRadius')}px;
`;
export const StyledCell = styled.div `
  & + & {
    ${BorderTop}
  }
`;
